'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
require("slick-carousel");
var Carousel;
(function (Carousel) {
    var MyCarousel = /** @class */ (function () {
        function MyCarousel() {
            this.pcWidth = 769;
            var self = this;
            var windowWidth = $(window).outerWidth();
            if (windowWidth < this.pcWidth) {
                self.movieSlick();
            }
        }
        MyCarousel.prototype.movieSlick = function () {
            $('#bulletMovieSlick').slick({
                arrows: true,
                autoplay: false,
                accessibility: true,
                dots: true,
                infinite: true,
                prevArrow: '<i class="fa fa-angle-left slick-prev-btn"></i>',
                nextArrow: '<i class="fa fa-angle-right slick-next-btn"></i>',
                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }
                ]
            });
        };
        MyCarousel.prototype.moveMessageTop = function () {
            var headerHeight = $('.paramHeader').outerHeight();
            var MessagePosition = $('#bulletMessageSlick').offset().top;
            $('html, body').animate({
                scrollTop: MessagePosition - headerHeight
            }, 'slow');
        };
        return MyCarousel;
    }());
    Carousel.MyCarousel = MyCarousel;
})(Carousel || (Carousel = {}));
exports.default = Carousel;
